export enum NumberFieldFormat {
  FormattedString = 0,
  Numeric = 1,
}

export enum CreatedOnFieldFormat
{
  Date = 0,
  DateTime = 1,
}

export enum ModifiedOnFieldFormat
{
  Date = 0,
  DateTime = 1,
}

export enum CreatedOnMobileFieldFormat
{
  Date = 0,
  DateTime = 1,
}

export enum ModifiedOnMobileFieldFormat
{
  Date = 0,
  DateTime = 1,
}

export enum LockedFieldFormat
{
  Numeric = 0,
  Boolean = 1,
}
